import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagPlacaEnVentasFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagPlacaEnVentas'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagPlacaEnVentas' label='Placa en Ventas' />}
    </Field>
  )
}

export default React.memo(FlagPlacaEnVentasFormGroup)
